import * as React from 'react';

interface TextProps {
  children: React.ReactNode | React.ReactNode[];
}

const Text = ({ children }: TextProps) => {
  return <p className="br-section-text">{children}</p>;
};

export default Text;
